module.exports = __webpack_public_path__ + "img/middlesection.a2d477dd.png";